module.exports = __webpack_public_path__ + "static/media/salute_benessere_miniatura.098c0375.jpg";